/**
 * Scrolls to an element on the page identified by the provided selector
 * @param {string} selector - CSS selector to identify the target element
 * @param {Object} [options] - Scrolling options
 * @param {ScrollBehavior} [options.behavior='smooth'] - Scroll behavior ('auto', 'smooth')
 * @param {ScrollLogicalPosition} [options.block='start'] - Vertical alignment ('start', 'center', 'end', 'nearest')
 * @param {ScrollLogicalPosition} [options.inline='nearest'] - Horizontal alignment ('start', 'center', 'end', 'nearest')
 * @returns {boolean} - Returns true if element was found and scrolled to, false otherwise
 */
export const scrollTo = (selector, options = {}) => {
  const element = document.querySelector(selector);
  if (element) {
    element.scrollIntoView({
      behavior: options.behavior || 'smooth',
      block: options.block || 'start',
      inline: options.inline || 'nearest',
      ...options
    });
    return true;
  }
  return false;
};